import moment from "moment";
class Operators {
  constructor(id, name, dateStart, dateEnd, isDefault) {
    this.id = id;
    this.name = name;
    this.dateStart = dateStart
      ? moment.utc(dateStart).format("DD-MM-YYYY")
      : null;
    this.dateEnd = dateEnd ? moment.utc(dateEnd).format("DD-MM-YYYY") : null;
    this.dateStartInput = dateStart
      ? moment.utc(dateStart).format("YYYY-MM-DD")
      : null;
    this.dateEndInput = dateEnd
      ? moment.utc(dateEnd).format("YYYY-MM-DD")
      : null;
    this.isDefault = isDefault;
    this.isDefaultBool = isDefault;
    this.isDefaultTable = isDefault ? "✔️" : "";
  }

  static fromJson({ operId, operNombre, fecDesde, fecHasta, def }) {
    return new Operators(operId, operNombre, fecDesde, fecHasta, def);
  }
}

export default Operators;
